import { render, staticRenderFns } from "./regionrecord.vue?vue&type=template&id=3daeed42"
import script from "./regionrecord.vue?vue&type=script&lang=js"
export * from "./regionrecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports